import "flatpickr/dist/themes/material_blue.css";
import {
  ADD_DETAIL_SHIPPER,
  DELETE_DETAIL_SHIPPER,
  GET_DETAIL_SHIPPER,
  GET_SHIPPER,
  UPDATE_DETAIL_MAIN_CONTACT,
} from "../../../helpers/url_api_constant";
import { AvField, AvForm } from "availity-reactstrap-validation";
import {
  Button,
  Form,
  FormGroup,
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Modal,
  Row,
  Badge,
} from "reactstrap";
import ConfirmDialog, {
  useConfirmDialog,
} from "../../../components/Custom/ConfirmDialog";
import MessageDialog, {
  useModalShowMessage,
} from "../../../components/Custom/MessageDialog";
import React, { useState, useEffect } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import Loading from "../../../components/Custom/Loading";
import OverButton from "../../../components/Custom/Overbutton";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import paginationFactory from "react-bootstrap-table2-paginator";
import { post } from "../../../helpers/api_helper";
//i18n
import { withTranslation } from "react-i18next";
import "../../../assets/scss/datatables.scss";
import { Link, useHistory, useParams } from "react-router-dom";
import { getPermission } from "../../../helpers/auth_helper";

function Person(props) {
  let history = useHistory();
  let { pid } = useParams();
  const permission = getPermission();

  const searchObj = { CUST_PID: pid, ALIAS_NAME: "", EMAIL: "" };
  const createObj = { PID: "", CUST_PID: pid, ALIAS_NAME: "", EMAIL: "", TEL: "" };
  const pidInfoCustomer = { PID: pid };

  // const customerData = {personShipper:""};
  const [readonly, setReadonly] = useState(false)
  const [pageAdd, setPageAdd] = useState(false);
  const [modelDeviceList, setModelDeviceList] = useState([]);
  const [createModel, setCreateModel] = useState(createObj);
  const [searchModel, setSearchModel] = useState(searchObj);
  const [userActionType, setUserActionType] = useState("");
  const [dataCustomer, setDataCustomer] = useState({});

  const [isLoading, setIsLoading] = useState(false);
  const {
    showMessage,
    toggleModalMessage,
    bodyMessageModal,
    titleMessageModal,
  } = useModalShowMessage();
  const { showConfirm, toggleConfirm, messageConfirm } = useConfirmDialog();
  const confirmSetMainContact = useConfirmDialog();
  const [selectedData, setSelectedData] = useState({});

  //ฝั่งซ้ายคือ ตัวแปล ฝั่งขวา คือ ฟังก์ชั่น Ex  modelDeviceList เป็น ตัวแปลที่ใช้ ส่วน  setModelDeviceListเป็น ฟังก์ชั่นที่ใช้ Set Value ให้ modelDeviceList

  // const listData = [
  //   {
  //     Id: "1",
  //     Name: "Jai Deeja",
  //     E_mail: "JaiDeeja@gmail.com",
  //     Phone: "080-xxx-xxxx",
  //   },

  //   {
  //     Id: "2",
  //     Name: "Somsak Mockdata",
  //     E_mail: "SomsakMockdata@gmail.com",
  //     Phone: "095-xxx-xxxx",
  //   },
  // ];

  const blackToPageShipper = () => {
    history.push("/shipper");
  };

  //sort Column//
  const defaultSorted = [
    {
      dataField: "PID",
      order: "asc",
    },
  ];
  //sort Column//

  //Sort Page//
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total ms-2">
      Showing {from} to {to} of {size} Results
    </span>
  );

  const options = {
    paginationSize: 4,
    pageStartIndex: 1,
    // alwaysShowAllBtns: true, // Always show next and previous button
    // withFirstAndLast: false, // Hide the going to First and Last page button
    // hideSizePerPage: true, // Hide the sizePerPage dropdown always
    // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "100",
        value: 100,
      },
      {
        text: "250",
        value: 250,
      },
      {
        text: "500",
        value: 500,
      },
      {
        text: "1000",
        value: 1000,
      },
    ],
  };
  //Sort Page//

  const SelectMainContact = (cellContent, row) => {
    // console.log(row)
    let color;
    let label;

    if (row.PRIORITY_FLAG == 1) {
      color = "success";
      label = "Main Contact";
    } else {
      color = "warning";
      label = "Switch to main contact";
    }
    return (
      <div className="justify-content-between">
        <Badge
          onClick={() => {
            if (row.PRIORITY_FLAG != 1 && permission.eSHP == true) {
              setSelectedData(row);
              confirmSetMainContact.toggleConfirm("Do you want to confirm a main contact ?");
            }
          }}
          className={"font-size-12 badge-soft-" + color}
          color="danger"
          pill
        >
          {label}
        </Badge>
      </div >
    );
  };

  // Action Button//
  const ButtonAction = (cellContent, row) => {
    // console.log(row);
    return (
      <div>
        {/* {row.PRIORITY_FLAG != 1 &&
          <Button
            className="me-1 mt-1"
            onClick={() => {
              setSelectedData(row);
              confirmSetMainContact.toggleConfirm("Do you want to confirm main contact ?");
            }}
            color="info"
          > Set to main contact </Button>
        } */}

        <OverButton
          onClick={() => {
            setReadonly(true);
            onEdit(row);
            setUserActionType("(View)");
          }}
          color="primary"
          icon="fas fa-eye"
          label="View"
        />

        {permission.eSHP && (
          <>
            <OverButton
              onClick={() => {
                setReadonly(false);
                onEdit(row);
                setUserActionType("(Edit)");
              }}
              color="info"
              icon="far fa-edit"
              label="Edit"
            />

            {/* <OverButton onClick={() => { setModalPerson(true) }} color="secondary" icon="fas fa-users" label="Person" /> */}
            <OverButton
              onClick={() => {
                onDelete(row);
              }}
              color="danger"
              icon="fas fa-trash-alt"
              label="Delete"
            />
          </>
        )}
      </div>
    );
  };
  // Action Button//

  //render Index//
  const CountIndexRow = (cell, row, rowIndex) => rowIndex + 1;
  //render Index//

  const rowStyleFontWhite = (row, rowIndex) => {
    const style = {};
    // style.fontWeight = 'bold';
    style.color = 'white';

    return style;
  };
  //headerColumn
  const columns = [
    {
      dataField: "Dummy",
      text: "No.",
      headerAlign: "center",
      align: "center",
      formatter: CountIndexRow,
      headerStyle: {
        width: "5%",
        fontSize: "12px",
      },
      style: {
        width: "5%",
        fontSize: "12px",
      },
    },
    {
      dataField: "ALIAS_NAME",
      text: "Contact Name",
      headerAlign: "center",
      align: "center",
      sort: true,
      headerStyle: {
        width: "20%",
        fontSize: "12px",
      },
      style: {
        width: "20%",
        fontSize: "12px",
      },
    },
    {
      dataField: "EMAIL",
      text: "E-mail",
      headerAlign: "center",
      align: "center",
      sort: true,
      headerStyle: {
        width: "20%",
        fontSize: "12px",
      },
      style: {
        width: "20%",
        fontSize: "12px",
      },
    },
    {
      dataField: "TEL",
      text: "Tel",
      headerAlign: "center",
      align: "center",
      sort: true,
      headerStyle: {
        width: "20%",
        fontSize: "12px",
      },
      style: {
        width: "20%",
        fontSize: "12px",
      },
    },
    {
      dataField: "Main Contact",
      formatter: SelectMainContact,
      text: "Main Contact",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "20%",
        fontSize: "12px",
      },
      style: (cell, row, rowIndex, colIndex) => {
        if (row.PRIORITY_FLAG != 1) {
          return {
            width: "20%",
            fontSize: "12px",
            cursor: "pointer",
          };
        }
        return {
          width: "20%",
          fontSize: "12px",
          cursor: "default",
        };
      },
      // style: {
      //   width: "20%",
      //   fontSize: "12px",
      // },
    },
    {
      dataField: "df1",
      text: "Action",
      headerAlign: "center",
      align: "center",
      isDummyField: true,
      formatter: ButtonAction,
      headerStyle: {
        width: "11%",
        fontSize: "12px",
      },
      style: {
        width: "11%",
        fontSize: "12px",
      },
    },
  ];
  //headerColumn

  //onInit//
  useEffect(function () {
    resetSearch();
    resetModel();
    // setModelDeviceList(listData);


    ///fixed header table
    let tableId = "person-table";
    let scrollY = 232;
    function fixedTableHeader() {
      let headerTable = document.querySelector(`#${tableId} thead`);
      if (window.scrollY >= scrollY) {
        headerTable.classList.add("fixed-header");

        resizeTableHeader();
      } else {
        headerTable.classList.remove("fixed-header");
      }
    }
    function resizeTableHeader() {
      setTimeout(() => {
        let headerTable = document.querySelector(`#${tableId} thead`);
        let tr = document.querySelector(`#${tableId} tbody tr`);
        let th = headerTable.querySelector(".header-style");
        if (tr) {
          for (var i = 0; i < tr.childNodes.length; i++) {
            th.childNodes[i].style.width = `${tr.childNodes[i].offsetWidth}px`;
          }
        }
      }, 1);
    }
    window.addEventListener("scroll", fixedTableHeader);
    document
      .querySelector(`#vertical-menu-btn`)
      .addEventListener("click", resizeTableHeader);
    return () => {
      window.removeEventListener("scroll", fixedTableHeader);
      document.querySelector(`#vertical-menu-btn`)?.removeEventListener("click", resizeTableHeader);
    };
  }, []);
  //onInit//

  //Function CURL
  const resetSearch = () => {
    setSearchModel(searchObj);
    fetchData(searchObj);
    getInformationCustomer(pidInfoCustomer);
  };

  const resetModel = () => {
    setCreateModel(createObj);
  };

  const onSearch = () => {
    fetchData(searchModel);
  };

  const onAdd = () => {
    setReadonly(false);
    resetModel();
    setPageAdd(true);
    setUserActionType("(Add Record)");
  };

  const onEdit = row => {

    setCreateModel(row);
    setPageAdd(true);
  };

  const onDelete = row => {
    setCreateModel(row);
    toggleConfirm("Do you want to delete ?");
  };

  const validateForm = () => {
    let bResult = true;
    if (createModel.ALIAS_NAME == "") {
      bResult = false;
    }

    if (createModel.EMAIL == "") {
      bResult = false;
    }

    if (createModel.TEL == "") {
      bResult = false;
    }
    return bResult;
  };

  // อันนี้เขียนเป็นแบบ .then
  // const fetchData = () => {
  //   let createModel = {
  //     customerType:"test",
  //   };
  //   get(GET_CUSTOMER_TYPE,createModel)
  //   .then((res) => {
  //     setModelDeviceList(res)
  //   }).catch((err) =>{
  //     alert('true')
  //   })
  // };
  // อันนี้เขียนเป็นแบบ .then

  // อันนี้เขียนแบบ async , await

  const getInformationCustomer = async (pidCustomer) => {
    setIsLoading(true);
    try {
      let res = await post(GET_SHIPPER, pidCustomer);
      // console.log(res);
      setDataCustomer(res.data.customerList[0]);
    } catch (err) {
      toggleModalMessage(err.message);
    }
    setIsLoading(false);
  };

  const fetchData = async (searchData) => {
    setIsLoading(true);
    try {
      let res = await post(GET_DETAIL_SHIPPER, searchData);
      setModelDeviceList(res.data.customerContactList);
    } catch (err) {
      toggleModalMessage(err.message);
    }
    setIsLoading(false);
  };

  const saveData = async () => {
    if (validateForm()) {
      setIsLoading(true);
      try {
        let res = await post(ADD_DETAIL_SHIPPER, createModel);
        // console.log(res);
        if (res.resultCode == 200) {
          res.isEditMode == 0 ? toggleModalMessage("Save success.") : toggleModalMessage("Update success.");
          setPageAdd(false);
          fetchData(searchModel);
        } else {
          toggleModalMessage(res.resultDescription);
        }
      } catch (err) {
        toggleModalMessage(err.message);
      }
      setIsLoading(false);
    }
  };

  const deleteData = async () => {
    setIsLoading(true);
    try {
      let res = await post(DELETE_DETAIL_SHIPPER, createModel);
      toggleConfirm();
      if (res.resultCode == 200) {
        toggleModalMessage("Delete success.");
        fetchData(searchModel);
      } else {
        toggleModalMessage(res.resultDescription);
      }
      setIsLoading(false);
    } catch (err) {
      toggleConfirm();
      toggleModalMessage(err.message);
      setIsLoading(false);
    }
  };

  //Function CURL

  const setMainContact = async () => {
    confirmSetMainContact.toggleConfirm();
    setIsLoading(true);
    try {
      let res = await post(UPDATE_DETAIL_MAIN_CONTACT, selectedData);
      fetchData(searchModel);
      setSelectedData({});
    } catch (err) {
      toggleModalMessage(err.message);
    }
    setIsLoading(false);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <div className="page-title-box d-sm-flex align-items-center justify-content-between pb-0">
                    <h1 className="mb-sm-0 font-size-20">
                      {" "}
                      {props.t("Person")} : {dataCustomer.FULL_NAME}
                    </h1>
                    <div className="page-title-right">
                      <ol className="breadcrumb m-0">
                        <li className="breadcrumb-item">
                          <Link to="#" style={{ color: "#556ee6" }}>
                            Master Data Setting
                          </Link>
                        </li>
                        <li className="breadcrumb-item">
                          <Link to="/shipper" style={{ color: "#556ee6" }}>
                            Shipper
                          </Link>
                        </li>
                        <li className="breadcrumb-item active">Person</li>
                      </ol>
                    </div>
                  </div>
                  <hr />
                  <Row>
                    <Col sm="4">
                      <FormGroup className="row mt-0">
                        <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                          Contact Name
                        </Label>
                        <Col sm={8}>
                          <form className="search-box">
                            <div className="position-relative">
                              <input
                                type="text"
                                // style={{backgroundColor:"#FFFFFF"}}
                                className="form-control rounded-2 basicborder"
                                placeholder={props.t("Search Contact Name")}
                                onChange={e =>
                                  setSearchModel({
                                    ...searchModel,
                                    ALIAS_NAME: e.target.value,
                                  })
                                }
                                value={searchModel.ALIAS_NAME}
                              />
                              {/* {props.t("Search Meter Point ID") + "..."} */}
                              {/* <span className="bx bx-search-alt"></span> */}
                              <i className="bx bx-search-alt search-icon" />
                            </div>
                          </form>
                        </Col>
                      </FormGroup>
                    </Col>
                    <Col sm="4">
                      <FormGroup className="row mt-0">
                        <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                          E-mail
                        </Label>
                        <Col sm={8}>
                          <form className="search-box">
                            <div className="position-relative">
                              <input
                                type="text"
                                // style={{backgroundColor:"#FFFFFF"}}
                                className="form-control rounded-2 basicborder"
                                placeholder={props.t("Search E-mail")}
                                onChange={e =>
                                  setSearchModel({
                                    ...searchModel,
                                    EMAIL: e.target.value,
                                  })
                                }
                                value={searchModel.EMAIL}
                              />
                              {/* {props.t("Search Meter Point ID") + "..."} */}
                              <i className="bx bx-search-alt search-icon" />
                            </div>
                          </form>
                        </Col>
                      </FormGroup>
                    </Col>
                    <Col sm="4">
                      <FormGroup className="row">
                        <div className="d-grid gap-2 d-md-block">
                          <Button color="info" className="mt-0" onClick={() => onSearch()}>
                            <i className="fas fa-search"></i>
                            &nbsp; Search
                          </Button>
                          <Button color="warning" className="mt-0 ms-2" onClick={() => resetSearch()}>
                            <i className="fas fa-redo-alt"></i>
                            &nbsp; Reset
                          </Button>
                        </div>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row className="mb-1 mt-2">
                    <Col sm="3">
                      <div className="d-grid gap-2 d-md-block">
                        {permission.eSHP && (
                          <Button
                            onClick={() => onAdd()}
                            // className="btn-rounded"
                            color="success"
                            className="mt-2 mb-2"
                          >
                            <i className="fas fa-plus"></i>
                            &nbsp; Add
                          </Button>
                        )}
                      </div>
                    </Col>
                    <Col
                      sm="9"
                      className="d-flex align-items-center justify-content-end"
                    >
                      <div className="d-grid gap-2 d-md-block">
                        <Button
                          onClick={() => blackToPageShipper()}
                          // className="btn-rounded"
                          color="secondary"
                          className="mt-2 mb-2"
                        >
                          <i className="fas fa-angle-double-left"></i>
                          &nbsp; Back
                        </Button>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="12">
                      <div>
                        {/* className="table-responsive" */}
                        <BootstrapTable
                          id="person-table"
                          keyField="PID"
                          data={modelDeviceList}
                          columns={columns}
                          headerClasses="header-style"
                          rowStyle={rowStyleFontWhite}
                          // defaultSorted={defaultSorted}
                          pagination={paginationFactory(options)}
                        // selectRow={selectRow}
                        // hover
                        />
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/*start : ModalPageAdd */}
      <Modal size="lg" isOpen={pageAdd}>
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myModalLabel">
            Person {userActionType}
          </h5>
        </div>
        <div className="modal-body">
          <CardBody>
            <AvForm>
              <Row>
                <FormGroup className="row mb-3">
                  <Label className="col-sm-3 col-form-label text-center">
                    <span style={{ color: "#FF0E03" }}>* </span>
                    Contact Name
                  </Label>
                  <Col sm={8}>
                    <AvField
                      // style={{ border: "solid 1px #FFFFFF" }}
                      // readOnly={readonly}
                      disabled={readonly}
                      name="ALIAS_NAME"
                      type="text"
                      errorMessage="Enter Contact Name"
                      className="form-control basicborder"
                      validate={{ required: { value: true } }}
                      onChange={e =>
                        setCreateModel({
                          ...createModel,
                          ALIAS_NAME: e.target.value,
                        })
                      }
                      value={createModel.ALIAS_NAME}
                    />
                  </Col>
                </FormGroup>
              </Row>
              <Row>
                <FormGroup className="row mb-3">
                  <Label className="col-sm-3 col-form-label text-center">
                    <span style={{ color: "#FF0E03" }}>* </span>
                    E-mail
                  </Label>
                  <Col sm={8}>
                    <AvField
                      // style={{ border: "solid 1px #FFFFFF" }}
                      // readOnly={readonly}
                      disabled={readonly}
                      name="EMAIL"
                      type="text"
                      errorMessage="Enter E-mail"
                      className="form-control basicborder"
                      validate={{ required: { value: true } }}
                      onChange={e =>
                        setCreateModel({
                          ...createModel,
                          EMAIL: e.target.value,
                        })
                      }
                      value={createModel.EMAIL}
                    />
                  </Col>
                </FormGroup>
              </Row>
              <Row>
                <FormGroup className="row mb-3">
                  <Label className="col-sm-3 col-form-label text-center">
                    <span style={{ color: "#FF0E03" }}>* </span>
                    Tel
                  </Label>
                  <Col sm={8}>
                    <AvField
                      // style={{ border: "solid 1px #FFFFFF" }}
                      // readOnly={readonly}
                      disabled={readonly}
                      name="TEL"
                      type="text"
                      errorMessage="Enter Tel"
                      className="form-control basicborder"
                      validate={{ required: { value: true } }}
                      onChange={e =>
                        setCreateModel({
                          ...createModel,
                          TEL: e.target.value,
                        })
                      }
                      value={createModel.TEL}
                    />
                  </Col>
                </FormGroup>
              </Row>
              <div className="text-center mt-2">
                {!readonly &&
                  <button
                    type="submit"
                    className="btn btn-success me-2"
                    onClick={() => saveData()}
                  >
                    <i className="far fa-save"></i> Save
                  </button>
                }
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => setPageAdd(false)}
                >
                  <i className="fas fa-times"></i> Close
                </button>
              </div>
            </AvForm>
          </CardBody>
          {createModel.PID && (
            <Row className="mt-2">
              <Col sm={6}>
                <span
                  className="d-flex align-items-center justify-content-start"
                  style={{ color: "#556ee6" }}
                >
                  Create By : {createModel.CREATE_USER} (  {moment(createModel.CREATE_DATE).format(
                    "D/MM/YYYY, H:mm:ss"
                  )} )
                </span>
              </Col>
              <Col sm={6}>
                <span
                  className="d-flex align-items-center justify-content-end"
                  style={{ color: "#556ee6" }}
                >
                  Update By :  {createModel.UPDATE_USER} (  {moment(createModel.UPDATE_DATE).format(
                    "D/MM/YYYY, H:mm:ss"
                  )} )

                </span>
              </Col>
            </Row>
          )}
        </div>
        {/* -- Model Footer-- */}
        {/* <div className="modal-footer">
                <button type="button" className="btn btn-success">Save</button>
                <button type="button" className="btn btn-light" onClick={() =>
                  this.setState({ modal_backdrop: false })
                }>Close</button>
              </div> */}
        {/* -- Model Footer-- */}
      </Modal>
      {/*end : PageAdd */}

      {/*Loading */}
      <Loading show={isLoading} />
      {/*Loading */}

      {/* MessageDialog */}
      <MessageDialog
        isOpen={showMessage}
        hide={toggleModalMessage}
        title={titleMessageModal}
        message={bodyMessageModal}
      />

      {/* comfirmDialog */}
      <ConfirmDialog
        isOpen={showConfirm}
        hide={toggleConfirm}
        message={messageConfirm}
        onConfirm={deleteData}
      />

      {/* comfirmDialogSetMainContact */}
      <ConfirmDialog
        isOpen={confirmSetMainContact.showConfirm}
        hide={confirmSetMainContact.toggleConfirm}
        message={confirmSetMainContact.messageConfirm}
        onConfirm={setMainContact}
      />

    </React.Fragment>
  );
}

Person.propTypes = {
  t: PropTypes.any,
};

const mapStateToProps = ({ Person }) => ({});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Person));

// function RenderList(prop) {
//   console.log(prop);

//   return (<tr>
//     <td>{prop.indexlist}</td>
//     <td>{prop.data.MeterPointID}</td>
//     <td>{prop.data.Customer}</td>
//     <td>{prop.data.CustomerType}</td>
//     <td>{prop.data.CommunicationType}</td>
//     <td>{prop.data.Zone}</td>
//     <td>{prop.data.Point}</td>
//     <td>{prop.data.Region}</td>
//     <td>{prop.data.Area}</td>
//     <td>{prop.data.BVZoning}</td>
//     <td>{prop.data.BV}</td>
//     <td>
//       <Button className="me-1"
//         onClick={() =>
//           setPageAdd(true)
//         }
//         color="info"
//       >
//         <i className="far fa-edit"></i>
//         &nbsp; Edit
//       </Button>
//       <Button
//         onClick={() =>
//           setModalDelete(true)
//         }
//         // className="btn-rounded"
//         color="danger"
//       >
//         <i className="fas fa-trash-alt"></i>
//         &nbsp; Delete
//       </Button>
//     </td>
//   </tr>)
// }
